import { Navigate, Outlet, useLocation } from 'react-router';
import { session } from '../app/core.ts';

/** Without a session, every admin page goes to Entrar and comes back after. */
export function RequireSession() {
  const signedIn = session(state => state.session !== null);
  const location = useLocation();
  if (!signedIn) {
    const back = location.pathname === '/' ? '' : `?back=${encodeURIComponent(location.pathname + location.search)}`;
    return <Navigate to={`/join${back}`} replace />;
  }
  return <Outlet />;
}
